import _ from 'lodash';
(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("facebookService", ["$sce", facebookService]);
    function facebookService($sce) {
        var facebookServiceFactory = {};
        var supportedLanguages = [
            "af_ZA",
            "sq_AL",
            "ar_AR",
            "hy_AM",
            "ay_BO",
            "az_AZ",
            "eu_ES",
            "be_BY",
            "bn_IN",
            "bs_BA",
            "bg_BG",
            "ca_ES",
            "ck_US",
            "hr_HR",
            "cs_CZ",
            "da_DK",
            "nl_NL",
            "en_PI",
            "en_US",
            "eo_EO",
            "et_EE",
            "fo_FO",
            "tl_PH",
            "fi_FI",
            "fr_CA",
            "fr_FR",
            "gl_ES",
            "ka_GE",
            "de_DE",
            "el_GR",
            "gn_PY",
            "gu_IN",
            "he_IL",
            "hi_IN",
            "hu_HU",
            "is_IS",
            "id_ID",
            "ga_IE",
            "it_IT",
            "ja_JP",
            "jv_ID",
            "kn_IN",
            "kk_KZ",
            "km_KH",
            "tl_ST",
            "ko_KR",
            "ku_TR",
            "la_VA",
            "lv_LV",
            "fb_LT",
            "li_NL",
            "lt_LT",
            "mk_MK",
            "mg_MG",
            "ms_MY",
            "ml_IN",
            "mt_MT",
            "mr_IN",
            "mn_MN",
            "ne_NP",
            "S?mi",
            "nb_NO",
            "nn_NO",
            "ps_AF",
            "fa_IR",
            "pl_PL",
            "pt_BR",
            "pt_PT",
            "pa_IN",
            "qu_PE",
            "ro_RO",
            "rm_CH",
            "ru_RU",
            "sa_IN",
            "sr_RS",
            "zh_CN",
            "sk_SK",
            "sl_SI",
            "so_SO",
            "es_LA",
            "es_CL",
            "es_CO",
            "es_MX",
            "es_ES",
            "es_VE",
            "sw_KE",
            "sv_SE",
            "sy_SY",
            "tg_TJ",
            "ta_IN",
            "tt_RU",
            "te_IN",
            "th_TH",
            "zh_HK",
            "zh_TW",
            "tr_TR",
            "uk_UA",
            "ur_PK",
            "uz_UZ",
            "vi_VN",
            "cy_GB",
            "xh_ZA",
            "yi_DE",
            "zu_ZA"
        ];
        facebookServiceFactory.getShareLink = function (locale, link) {
            //https://stackoverflow.com/questions/5776567/facebook-open-graph-not-clearing-cache
            link = link + "?fbrefresh=CAN_BE_ANYTHING&source=Facebook";
            locale = locale.replace("-", "_");
            var supported = _.find(supportedLanguages, function (item) { return item === locale; });
            if (!supported)
                locale = "en_US";
            var src = "https://www.facebook.com/plugins/share_button.php?locale=" + locale + "&href=" + link + "&layout=button&size=large&mobile_iframe=true&margin=auto&display=block&appId";
            return $sce.trustAsResourceUrl(src);
        };
        return facebookServiceFactory;
    }
}());
